export default __webpack_public_path__ + "static/media/tab2_img3.90c4bc86.png";